(function() {
	'use strict';

	angular.module('quantixApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider','$ocLazyLoadProvider' ];

	function stateConfig($stateProvider,$ocLazyLoadProvider) {
		
		$ocLazyLoadProvider
		.config({
			'debug' : false, /*
								 * for debugging ocLazyLoad module
								 * 'true/false'
								 */
			'events' : true, /*
								 * for event ocLazyLoad module
								 * 'true/false'
								 */
			'modules' : [ {
				name : 'industryProfileModule', /*
									 * injecting 
									 * Module for ocLazyLoad
									 */
				/* files for lazy load */
				files : [
					'app/services/industry/industryProfile.service.js',
						'app/industry/industryProfile/industryProfile.controller.js',
						'app/industry/industryProfile/industryProfileSetAlert.controller.js',
						'app/industry/industryProfile/industryProfileNewsController.controller.js',
						'app/services/companyProfile/companyProfile.service.js']
			} ]
		});
		
		$stateProvider
				.state(
						'industryProfileMain',
						{
							parent : 'app',
							url : '/industryProfileMain',
							data : {
								authorities : []
							},
							views : {
								'content@' : {
									templateUrl : 'app/industry/industryProfile/industryProfileMain.html',
									controller : 'industryProfileController',
									controllerAs : 'vm'
								}
							},
							resolve : {
								loadMyCtrl : [
										'$ocLazyLoad',
										function($ocLazyLoad) {
											/* Resolve promise and load before view */
											return $ocLazyLoad.load('industryProfileModule'); 
										} ],
							}
						})
				.state(
						'industryProfileNews',
						{
							parent : 'app',
							url : '/industryProfileNews',
							data : {
								authorities : []
							},
							params : {
								objtodisplay : null,
								movements : null,
								industryId : null,
								indicator : null,
								drill : null,
								industryName : null,
								industryAlertFlag : null,
								industryType : null,
								newsreport : null,
								newsdata : null,
								label : null,
								newsHeadline:null,
								id:null,
								compObj:null
								

							},
							views : {
								'content@' : {
									templateUrl : 'app/industry/industryProfile/industryProfileNews.html',
									controller : 'industryProfileNewsController',
									controllerAs : 'vm'

								}
							}
						})
				.state(
						'industryProfileDetails',
						{
							parent : 'app',
							url : '/industryProfileDetails',
							data : {
								authorities : []
							},
							params : {
								objtodisplay : null,
								movements : null,
								industryId : null,
								indicator : null,
								drill : null,
								industryName : null,
								industryAlertFlag : null,
								industryType : null,
								news : null,
								newsreport : null,
								newsdata : null,
								year : null,
								label : null,
								companyYear : null,
								compObj:null
							},
							views : {
								'content@' : {
									templateUrl : 'app/industry/industryProfile/industryProfileDetails.html',
									controller : 'industryProfileDetailsController',
									controllerAs : 'vm'
								}
							}
						});
	}
})();
